module.exports = __webpack_public_path__ + "img/08_WebFlow_08.eaa58db8.png";